<template>
  <v-container fluid>
    <v-card width="100%" class="mt-8">
      <v-col cols="12">
        <v-row no-gutters>
          <v-col>
            <h2 class="primary--text text-uppercase">
              {{localization.fotosApertura}}
            </h2>
            <v-divider class="divider_subtitle"></v-divider>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-flex mt-4 mr-2 ml-2 xs12 sm12 md3 aling-center
            v-for="(item, i) in fotosApertura" :key="i+'-apertura'" mb-3>
            <v-card>
              <v-card-subtitle class="pb-0">{{ item.description }}</v-card-subtitle>
              <v-card-text class="text--primary">
                <v-img v-bind:src="'data:image/*;base64,' + item.smallPicture" width="300" height="200"
                  @click="expandImg('data:image/*;base64,' + item.smallPicture, item.description, item.id)"></v-img>
              </v-card-text>
              <v-card-text class="pb-0 text-right">{{ item.fechaAlta }}</v-card-text>
              <v-card-actions v-if="!rolCliente">
                <v-btn v-if="!rolProveedor" color="red" text @click="openDeleteDialog(item.id, '1')">
                  {{localization.deleteButton}}
                </v-btn>
                <v-btn color="primary" @click="descargarDocumento(item.id)" text>
                  {{localization.downloadButton}}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-row>
        <v-row no-gutters justify="end" class="mt-2" v-if="!rolCliente">
          <v-btn color="primary" small fab @click="openDialogPlan('1')" class="mr-4" v-if="this.plano !== null">
            <v-icon>mdi-home</v-icon>
          </v-btn>

          <v-btn color="primary" small fab @click="opendDialogImage('1')">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-card>

    <v-card width="100%" class="mt-8">
      <v-col cols="12">
        <v-row no-gutters>
          <v-col>
            <h2 class="primary--text text-uppercase">
              {{localization.fotosCierre}}
            </h2>
            <v-divider class="divider_subtitle"></v-divider>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-flex mt-4 mr-2 ml-2 xs12 sm12 md3 aling-center
            v-for="(item, i) in fotosCierre" :key="i+'-cierre'" mb-3>
            <v-card>
              <v-card-subtitle class="pb-0">{{ item.description }}</v-card-subtitle>
              <v-card-text class="text--primary">
                <v-img v-bind:src="'data:image/*;base64,' + item.smallPicture" width="300" height="200"
                  @click="expandImg('data:image/*;base64,' + item.smallPicture, item.description, item.id)"></v-img>
              </v-card-text>
              <v-card-text class="pb-0 text-right">{{ item.fechaAlta }}</v-card-text>
              <v-card-actions v-if="!rolCliente">
                <v-btn v-if="!rolProveedor" color="red" text @click="openDeleteDialog(item.id, '3')">
                  {{localization.deleteButton}}
                </v-btn>
                <v-btn color="primary" @click="descargarDocumento(item.id)" text>
                  {{localization.downloadButton}}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-row>
        <v-row no-gutters justify="end" class="mt-2" v-if="!rolCliente">
          <v-btn color="primary" small fab @click="opendDialogImage('3')">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-card>

    <v-card width="100%" class="mt-8">
      <v-col cols="12">
        <v-row no-gutters>
          <v-col>
            <h2 class="primary--text text-uppercase">
              {{localization.documentacion}}
            </h2>
            <v-divider class="divider_subtitle"></v-divider>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-flex mt-4 mr-2 ml-2 xs12 sm12 md3 aling-center
            v-for="(item, i) in documentos" :key="i+'-docu'" mb-3>
            <v-card>
              <v-card-subtitle class="pb-0">{{ item.description }}</v-card-subtitle>
              <v-card-text class="text--primary" v-if="item.mime && item.mime.indexOf('image/') >= 0">
                <v-img v-bind:src="'data:image/*;base64,' + item.document" max-height="500" max-width="500"></v-img>
              </v-card-text>
              <v-card-text class="text--primary text-center" v-else>
                <v-icon size="60">description</v-icon>
              </v-card-text>
              <v-card-text class="pb-0 text-right">{{ item.fechaAlta }}</v-card-text>
              <v-card-actions>
                <v-btn  v-if="!rolCliente && !rolProveedor" color="red" text @click="openDeleteDialog(item.id, '5')">
                  {{localization.deleteButton}}
                </v-btn>
                <v-btn color="primary" @click="descargarDocumento(item.id)" text>
                  {{localization.downloadButton}}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-row>
        <v-row no-gutters justify="end" class="mt-2" v-if="!rolCliente">
          <v-btn color="primary" small fab @click="opendDialogImage('5')">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-card>

    <v-card width="100%" class="mt-8" v-if="!rolCliente">
      <v-col cols="12">
        <v-row no-gutters>
          <v-col>
            <h2 class="primary--text text-uppercase">
              {{localization.documentacionVisita}}
            </h2>
            <v-divider class="divider_subtitle"></v-divider>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-flex mt-4 mr-2 ml-2 xs12 sm12 md3 aling-center
            v-for="(item, i) in documentosVisita" :key="i+'-docu'" mb-3>
            <v-card>
              <v-card-subtitle class="pb-0">{{ item.description }}</v-card-subtitle>
              <v-card-text class="text--primary" v-if="item.mime && item.mime.indexOf('image/') >= 0">
                <v-img v-bind:src="'data:image/*;base64,' + item.document" max-height="500" max-width="500"></v-img>
              </v-card-text>
              <v-card-text class="text--primary text-center" v-else>
                <v-icon size="60">description</v-icon>
              </v-card-text>
              <v-card-text class="pb-0 text-right">{{ item.fechaAlta }}</v-card-text>
              <v-card-actions>
                <v-btn v-if="!rolProveedor" color="red" text @click="openDeleteDialog(item.id, '5')">
                  {{localization.deleteButton}}
                </v-btn>
                <v-btn color="primary" @click="descargarDocumento(item.id)" text>
                  {{localization.downloadButton}}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-row>
        <v-row no-gutters justify="end" class="mt-2">
          <v-btn color="primary" small fab @click="opendDialogImage('11')">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-card>
    <AddPicture v-model="dialogImage" id="dialogImage" :carpeta="this.carpetaIdSelected"
      :incidence="this.incidencia.id" :visit="this.incidencia.visitaId" :title="addPictureTitle" @success="mountedAllImages()"/>
    <AddPlan v-model="dialogPlan" :incidenciaCompleta="this.incidencia" :carpeta="this.carpetaIdSelected"
      :incidence="this.incidencia.id" :plano="this.plano" :visit="this.incidencia.visitaId" :title="addPictureTitle" @success="mountedAllImages()"/>
    <ConfirmDialog :dialogFlag="dialogDelete" @cancel="dialogDelete = false"
      :text="localization.deleteMessage" :textoBoton="$t('eliminar')" :textoTitulo="$t('eliminar')" @close="deleteItem()"/>
    <FullSizeImg :imgId="imgId" :imgUrl="imgUrl" :description="imgDesc" v-model="openFullSize" id="openFullSize" />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AddPicture from './addPictureDialog'
import AddPlan from './addPlanDialog'
import ConfirmDialog from '../../custom/confirmDialog'
import FullSizeImg from '../../custom/fullSizeImgPopUp'
import moment from 'moment'

export default {
  components: {
    AddPicture,
    AddPlan,
    ConfirmDialog,
    FullSizeImg
  },
  props: {
    incidencia: Object
  },
  data () {
    return {
      valuesApertura: {},
      valuesCierre: {},
      valuesCierreFirma: {},
      valuesDocumentos: {},
      // valuesResumen: {},
      valuesDocumentosVisit: {},
      dialogImage: false,
      dialogPlan: false,
      carpetaIdSelected: '',
      dialogDelete: false,
      itemToDelete: '',
      openFullSize: false,
      imgUrl: '',
      imgId: null,
      imgDesc: '',
      addPictureTitle: null,
      loader: null,
      plano: null
    }
  },
  async mounted () {

    let plano = await this.getPlanos({
      codPromocion: this.incidencia.promocionCodigo, // 9998, -> ejemplo en desarrollo
      uhedit: this.incidencia.uhedit, // 'VI-003-003-A' -> ejemplo en desarrollo
    })
    this.plano = plano?.data?.plan ?? null
    
    const loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false
      })
    this.valuesApertura.objetoId = this.incidencia.id
    this.valuesApertura.tipoObjetoId = '2'
    this.valuesApertura.carpetaId = '1'

    this.valuesCierre.objetoId = this.incidencia.id
    this.valuesCierre.tipoObjetoId = '2'
    this.valuesCierre.carpetaId = '3'

    this.valuesCierreFirma.objetoId = this.incidencia.id
    this.valuesCierreFirma.tipoObjetoId = '2'
    this.valuesCierreFirma.carpetaId = '4'

    this.valuesDocumentos.objetoId = this.incidencia.id
    this.valuesDocumentos.tipoObjetoId = '2'
    this.valuesDocumentos.carpetaId = '5'
    this.valuesDocumentos.adjuntarFotos = true
    
    // 311.463 - El parte de alta lo podrá ver cualquier rol o usuario con acceso a la galería o a la documentación de la incidencia.
    // if ( this.rolCliente ) {
      this.valuesDocumentos.obtenerParteAlta = true
    // }
    // else {
      // this.valuesDocumentos.obtenerParteAlta = false
    // }

    this.valuesDocumentosVisit.objetoId = this.incidencia.visitaId
    this.valuesDocumentosVisit.tipoObjetoId = '3'
    this.valuesDocumentosVisit.carpetaId = '11'
    this.valuesDocumentosVisit.adjuntarFotos = true

    /* this.valuesResumen.objetoId = this.incidencia.visitaId
    this.valuesResumen.tipoObjetoId = '3'
    this.valuesResumen.carpetaId = '11'
    this.valuesResumen.adjuntarFotos = true
 */
    await this.getAllImages()
    loader.hide()
  },
  methods: {
    ...mapActions({
      getSmallPicturesApertura: 'incidencias/getSmallPicturesApertura',
      getSmallPicturesCierre: 'incidencias/getSmallPicturesCierre',
      getDocuments: 'incidencias/getDocuments',
      getDocumentsVisit: 'incidencias/getDocumentsVisit',
      delPicture: 'incidencias/delPicture',
      delDocument: 'incidencias/delDocument',
      getDocumentsById: 'incidencias/getDocumentsById',
      // getDocumentosResumen: 'incidencias/getDocumentosResumen',
      cleanPreviewDocuments: 'incidencias/cleanPreviewDocuments',
      getPlanos: 'inmuebles/getPlanos'
    }),
    formatedDate(date) {
      return moment(date).format('DD-MM-YYYY HH:mm')
    },
    expandImg (data, description, id) {
      this.imgId = id
      this.imgUrl = data
      // console.log(this.imgUrl)
      this.imgDesc = description
      this.openFullSize = true
    },
    descargarDocumento (id) {
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      })

      this.getDocumentsById(id)
        .then(() => {
          var binario = atob(this.singleDoc[0].document.toString().replace(/(\r\n|\n|\r)/gm ,''))
          var array = []
          for (var i = 0; i < binario.length; i++) {
            array.push(binario.charCodeAt(i))
          }
          var blob = new Blob([new Uint8Array(array)], { type: this.singleDoc[0].mime })
          if (window.navigator.msSaveBlob) {
            window.navigator.msSaveOrOpenBlob(blob, this.singleDoc[0].name)
          } else {
            var a = window.document.createElement('a')
            a.href = window.URL.createObjectURL(blob, { type: this.singleDoc[0].mime })
            a.download = this.singleDoc[0].name
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
          }
          this.loader.hide()
        })
        .catch(e => {
          return e
        })
    },
    async getAllImages () {
      this.cleanPreviewDocuments()
      await this.getSmallPicturesApertura(this.valuesApertura)
      await this.getSmallPicturesCierre(this.valuesCierre)
      // this.getSmallPictures(this.valuesCierreFirma)
      await this.getDocuments(this.valuesDocumentos)
      // await this.getDocumentosResumen(this.valuesResumen)
      if (!this.rolCliente) {
        await this.getDocumentsVisit(this.valuesDocumentosVisit)
      }
      // await this.getDocumentsVisit(this.valuesDocumentosVisit)
    },
    async mountedAllImages() {
      const loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false
      })
      await this.getAllImages()
      loader.hide()
    },
    decodeImg (img) {
      return btoa(atob(img))
    },
    openDialogPlan(carpetaId) {
      this.addPictureTitle = this.$t('subirImagen')
      this.carpetaIdSelected = carpetaId
      this.dialogPlan = true
    },
    opendDialogImage (carpetaId) {
      if (carpetaId === '5' || carpetaId === '11') {
        this.addPictureTitle = this.$t('subirDocumento')
      } else {
        this.addPictureTitle = this.$t('subirImagen')
      }
      this.carpetaIdSelected = carpetaId
      this.dialogImage = true
    },
    openDeleteDialog (id, carpeta) {
      this.itemToDelete = id
      this.carpetaIdSelected = carpeta
      this.dialogDelete = true
    },
    deleteItem () {
      if (this.carpetaIdSelected === '5') {
        // delete documento
        this.delDocument({
          id: this.itemToDelete,
          incidenceId: this.incidencia.id
        })
          .then(() => {
            this.carpetaIdSelected = ''
            this.getAllImages()
            this.dialogDelete = false
          })
          .catch(e => {
            return e
          })
      } else {
        // delete imagen apertura o cierre
        this.delPicture({
          id: this.itemToDelete,
          incidenceId: this.incidencia.id
        })
          .then(() => {
            this.carpetaIdSelected = ''
            this.getAllImages()
            this.dialogDelete = false
          })
          .catch(e => {
            return e
          })
      }
    },
    async inmuebleConPlano() {
      console.log('inmueble con plano??')
      return false
    }
  },
  computed: {
    ...mapGetters({
      // documentosResumen: 'incidencias/getDocumentosResumen'
    }),
    localization () {
      return this.$t('verIncidencia.documentacion')
    },
    fotosApertura () {
      if (this.$store.state.incidencias.aperturaPictures) {
        return this.$store.state.incidencias.aperturaPictures
      }
      return []
    },
    fotosCierre () {
      if (this.$store.state.incidencias.cierrePictures) {
        return this.$store.state.incidencias.cierrePictures
      }
      return []
    },
    rolCliente () {
      return this.$store.state.login.rolCliente
    },
    rolProveedor (){
      return this.$store.state.login.rolProveedor
    },
    documentos () {
      return this.documentPictures // .concat(this.documentosResumen) --> el resumen pasa a estar en los documentos de visita
    },
    documentosVisita () {
      if (this.$store.state.incidencias.documentPicturesVisit) {
        return this.$store.state.incidencias.documentPicturesVisit
      }
      return []
    },
    documentPictures () {
      if (this.$store.state.incidencias.documentPictures) {
        return this.$store.state.incidencias.documentPictures
      }
      return []
    },
    singleDoc () {
      if (this.$store.state.incidencias.singleDoc) {
        return this.$store.state.incidencias.singleDoc
      }
      return []
    }
  }
}
</script>

<style scoped>
</style>
